<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.9,802.5v-2.45c3.86-0.19,6.96-3.29,7.15-7.15h2.45C10.3,798.12,6.12,802.3,0.9,802.5L0.9,802.5z M0.1,802.5
	c-5.21-0.21-9.41-4.39-9.6-9.6h2.48c0.19,3.85,3.28,6.95,7.13,7.15V802.5L0.1,802.5z M0.51,797.95c-1.37,0-2.62-0.5-3.58-1.33
	l0.95-0.95c0.52,0.43,1.15,0.74,1.85,0.88l0.8-2.99l0.79,2.98c0.67-0.13,1.29-0.43,1.8-0.85l0.95,0.95
	C3.12,797.46,1.88,797.95,0.51,797.95L0.51,797.95z M4.63,796.07l-0.95-0.95c0.42-0.51,0.72-1.14,0.86-1.82l-2.97-0.79l2.97-0.79
	c-0.13-0.69-0.44-1.32-0.87-1.84l0.95-0.95c0.83,0.96,1.33,2.21,1.33,3.58C5.95,793.88,5.46,795.12,4.63,796.07L4.63,796.07z
	 M-3.63,796.06c-0.83-0.95-1.33-2.19-1.33-3.55c0-1.36,0.5-2.61,1.33-3.57l0.96,0.96c-0.42,0.52-0.72,1.14-0.85,1.82l3.01,0.8
	l-3.01,0.8c0.13,0.67,0.43,1.28,0.84,1.79L-3.63,796.06L-3.63,796.06z M-9.5,792.1c0.21-5.2,4.4-9.39,9.6-9.6v2.47
	c-3.84,0.21-6.92,3.29-7.13,7.13H-9.5L-9.5,792.1z M8.05,792.1c-0.21-3.85-3.3-6.94-7.15-7.13v-2.47c5.21,0.2,9.39,4.39,9.6,9.6
	H8.05L8.05,792.1z M0.53,791.48l-0.8-3.02c-0.69,0.14-1.31,0.44-1.83,0.88l-0.95-0.95c0.96-0.83,2.21-1.33,3.57-1.33
	c1.36,0,2.6,0.5,3.55,1.33l-0.95,0.95c-0.51-0.42-1.12-0.72-1.78-0.86L0.53,791.48L0.53,791.48z"/>
</svg>

</template>